import fr from './fr' ;

export default
{
    fr : fr
};


// WEBPACK FOOTER //
// ./src/app/locale/index.js